import { OrganizationKeyName } from "../../../../model/Organization";

export const UPSERT_USER_VOUCHER = "SHOP:UPSERT_USER_VOUCHER";

export const upsertUserVoucherAction = (
  organization: OrganizationKeyName,
  data: any,
  userId: string,
  id?: string
) => ({
  type: UPSERT_USER_VOUCHER as typeof UPSERT_USER_VOUCHER,
  organization,
  data,
  userId,
  id,
});

export type UpsertUserVoucherAction = ReturnType<
  typeof upsertUserVoucherAction
>;
